import { ENTRYPOINT, getCookie } from "config/api";
import { fetchUtils } from "react-admin";

export const fetchJson = (
  url: string | URL,
  options: fetchUtils.Options = {},
) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  if (["POST", "PUT", "DELETE", "PATCH"].includes(options.method)) {
    (options.headers as Headers).set("X-CSRF-Token", getCookie("csrf_token"));
  }
  if (localStorage.getItem("token")) {
    if (!options.user) {
      options.user = {};
    }
    options.user.authenticated = true;
    options.user.token = "Bearer " + localStorage.getItem("token");
  }
  options.credentials = "include";
  return fetchUtils.fetchJson(url, options);
};

export function runAnalysis(analysisId: number) {
  const url = `${ENTRYPOINT}/analyses/${analysisId}/run`;
  return fetchJson(url, { method: "POST" });
}

export function stopAnalysis(analysisId: number) {
  const url = `${ENTRYPOINT}/analyses/${analysisId}/stop`;
  return fetchJson(url, { method: "POST" });
}

export function triggerWebhook(nodeId: number) {
  const url = `${ENTRYPOINT}/nodes/${nodeId}/hook`;
  return fetchJson(url, { method: "POST" });
}
